export default __webpack_public_path__ + "static/media/Knivsta.5a8dc99d.svg";